/* eslint-disable camelcase */
import { decamelizeKeys } from '../../lib';
import { getBackVersion } from '../../config';
import {
    Card,
    CardAddress,
    CardSnapshot,
    CustomerSnapshot,
} from '../../models';
import { RentalBillingSummarySnapshot } from '../../models/RentalPayment';
import api from '../api';

const createCardTenant = (
    encryptedCardData: string,
    publicKeyId: number,
    billingId: string,
    contractId: string
): Promise<CardSnapshot> => {
    return api.request({
        method: 'POST',
        action: 'CREATE_CREDIT_CARD',
        url: `${getBackVersion()}/rental/${contractId}/billings/${billingId}/cards`,
        data: {
            public_key_id: publicKeyId,
            value: encryptedCardData,
        },
    });
};

export type CreateBillingPaymentArgs = {
    customerId: number;
    deduplicationId: string;
    cardId: Card['id'];
};

const createTenantBillingPayment = (
    args: CreateBillingPaymentArgs,
    contractId: string,
    billingId: string
): Promise<RentalBillingSummarySnapshot> => {
    return api.request<RentalBillingSummarySnapshot>({
        method: 'POST',
        url: `${getBackVersion()}/rental/${contractId}/billings/${billingId}/credit_card_payment`,
        action: 'RENTAL_BILLING_CC_PAYMENT',
        data: decamelizeKeys({
            ...args,
        }),
    });
};

type SaveCustomerArgs = {
    document: string;
    name: string;
    email: string;
    phone: string;
};

const saveTenantCustomer = (
    { name, email, document, phone }: SaveCustomerArgs,
    contractId: string,
    billingId: string
): Promise<CustomerSnapshot> =>
    api.request<CustomerSnapshot>({
        method: 'POST',
        action: 'RENTAL_BILLING_CC_CREATE_CUSTOMER',
        url: `${getBackVersion()}/rental/${contractId}/billings/${billingId}/customers`,
        data: {
            name,
            email,
            document,
            phone,
        },
    });

const getTenantCustomer = (
    customerId: number,
    contractId: string,
    billingId: string
): Promise<CustomerSnapshot> =>
    api.request<CustomerSnapshot>({
        method: 'GET',
        action: 'RENTAL_BILLING_CC_GET_CUSTOMER',
        url: `${getBackVersion()}/rental/${contractId}/billings/${billingId}/customers/${customerId}`,
    });

const getTenantCard = (
    cardId: number,
    contractId: string,
    billingId: string
): Promise<CardSnapshot> =>
    api.request<CardSnapshot>({
        method: 'GET',
        action: 'RENTAL_BILLING_CC_GET_CARD',
        url: `${getBackVersion()}/rental/${contractId}/billings/${billingId}/cards/${cardId}`,
    });

const updateCardTenant = (
    cardId: number,
    address: CardAddress,
    contractId: string,
    billingId: string
): Promise<CardSnapshot> => {
    return api.request({
        method: 'PATCH',
        action: 'RENTAL_BILLING_CC_UPDATE_CARD',
        url: `${getBackVersion()}/rental/${contractId}/billings/${billingId}/cards/${cardId}`,
        data: decamelizeKeys(address),
    });
};

export {
    createCardTenant,
    updateCardTenant,
    createTenantBillingPayment,
    saveTenantCustomer,
    getTenantCustomer,
    getTenantCard,
};
